import React from 'react';

// Get the examples data array
import ExamplesData from './ExamplesData';


// Component styles
import './examples.scss';
import AppConfiguration from '../../../services/AppConfiguration';

const Examples = (props) => {
  const appConfig = AppConfiguration.getConfig();
  return (
    <div className='wtfExamples_container'>
      <div className='wtfExamples_title'>Try it out with one of these images!</div>
      <div className='wtfExamples_itemsContainer'>
        {
          ExamplesData.map((elem, index) => (
            <div
              className='wtfExamples_item'
              key={`example${elem.id}`}
              onClick={() => props.onExampleClicked(elem.original)}
              onKeyPress={() => props.onExampleClicked(elem.original)}
              role='button'
              tabIndex='0'
            >
              <img
                src={elem.thumbnail}
                alt={`Example ${index}`}
                className='wtfExamples_itemThumbnail'
              />
              <img
                src={`${appConfig.cdnUrl.url}/search.svg`}
                alt={`Example
              ${index} search icon`}
                className='wtfExamples_itemSearchIcon'
              />
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default Examples;



// WEBPACK FOOTER //
// ./src/components/Upload/Examples/Examples.js